import tmhRequest from "@/config/tmhRequest";

export default {
  searchRoom: function(data) {
    return tmhRequest({
      url: "/store/tmh/room/searchroom",
      method: "post",
      params: data
    });
  },
  searchListAllQrCode: function(data) {
    return tmhRequest({
      url: "/store/tmh/qrcode/searchlistallqrcode",
      method: "post",
      params: data
    });
  },
  createQrCode: function(data) {
    return tmhRequest({
      url: "/store/tmh/qrcode/createqrcode",
      method: "post",
      data: data
    });
  },
  resetQrCode: function(data) {
    return tmhRequest({
      url: "/store/tmh/qrcode/resetqrcode",
      method: "post",
      data: data
    });
  }
};



// WEBPACK FOOTER //
// ./src/api/tmh/store/qrcode.js